import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

import { EXCEPTION_REGEXP } from 'constants/index';
import { LINKS } from 'constants/links';

const useCheckForErrors = input => {
	const navigate = useNavigate();

	useEffect(() => {
		if (typeof input.detail === 'string' && EXCEPTION_REGEXP.test(input.detail)) {
			const parsedError = input.detail.replace(EXCEPTION_REGEXP, '').replace('"', '').trim();

			toast(parsedError, { type: 'error', style: { minWidth: '25rem', right: 0, top: 0, position: 'absolute' } });
			navigate(LINKS.SYSTEM_ERROR);
		}
	}, [input, navigate]);
};

export default useCheckForErrors;
